/**
 * AIP scoring rubrics — keep in sync with Albert-backend/utils/aipScoringRubrics.js
 */

export const FWB_ADL_ITEMS = [
  "adlBathing",
  "adlDressing",
  "adlEating",
  "adlTransferring",
  "adlToileting",
  "adlContinence",
];

export function scoreCareDaysPerWeek(days) {
  const d = Number(days);
  if (!Number.isFinite(d) || d <= 0) return 10;
  if (d >= 6) return 100;
  if (d >= 4) return 85;
  if (d >= 2) return 65;
  if (d >= 1) return 40;
  return 10;
}

export function countChecked(data, keys) {
  return keys.filter((k) => data?.[k] === true).length;
}

export function scoreFallHazardsFromCount(hazardCount) {
  const n = Number(hazardCount) || 0;
  if (n >= 5) return 0;
  if (n >= 3) return 1;
  if (n >= 2) return 3;
  if (n === 1) return 4;
  return 5;
}

export function scoreBathroomFromHazardCount(hazardCount) {
  const n = Number(hazardCount) || 0;
  if (n >= 7) return 0;
  if (n >= 5) return 1;
  if (n >= 3) return 2;
  if (n >= 1) return 3;
  return 4;
}

export function scoreKitchenFromHazardCount(hazardCount) {
  const n = Number(hazardCount) || 0;
  if (n >= 3) return 0;
  if (n >= 2) return 1;
  if (n === 1) return 2;
  return 4;
}

export function scoreHomeLayoutFromBarrierCount(barrierCount) {
  const n = Number(barrierCount) || 0;
  if (n >= 5) return 0;
  if (n >= 3) return 1;
  if (n >= 2) return 2;
  if (n === 1) return 3;
  return 4;
}

export function resolveGripStrengthScore(gripRight, gripLeft) {
  const right = Number(gripRight);
  const left = Number(gripLeft);
  const hasRight = Number.isFinite(right) && right > 0;
  const hasLeft = Number.isFinite(left) && left > 0;
  if (hasRight && hasLeft) return Math.max(right, left);
  if (hasRight) return right;
  if (hasLeft) return left;
  return 0;
}
